/** Copyright 2025 SAP SE or an SAP affiliate company. All rights reserved. */

import { clsx } from '@/utils/utils';
import { Bar, Card, List, ListItemStandard, Title } from '@ui5/webcomponents-react';
import TitleLevel from '@ui5/webcomponents/dist/types/TitleLevel';
import { useState } from 'react';

type SidebarItemProps = {
    label: string;
};

type SidebarProps<ItemProps extends SidebarItemProps> = {
    headerText: string;
    items?: ItemProps[];
    maxWidth?: React.CSSProperties['maxWidth'];
    gridColumn?: React.CSSProperties['gridColumn'];

    renderItem?: (item: ItemProps) => React.ReactNode;
};

export default function Sidebar<I extends SidebarItemProps>(props: SidebarProps<I>) {
    const { headerText, items = [], renderItem, maxWidth, gridColumn } = props;
    const [selected, setSelected] = useState<number>(0);

    return (
        <Card style={{ maxWidth, gridColumn }}>
            <List header={<Bar startContent={<Title size={TitleLevel.H5}>{headerText}</Title>} />} noDataText="Loading">
                {items.map((item, index: number) =>
                    renderItem ? (
                        renderItem(item)
                    ) : (
                        <ListItemStandard
                            key={item.label}
                            icon="initiative"
                            className={clsx({
                                'list-item-selected': selected === index,
                            })}
                            onClick={() => setSelected(index)}
                        >
                            {item.label}
                        </ListItemStandard>
                    )
                )}
            </List>
        </Card>
    );
}
